﻿import type { RouteRecordRaw } from 'vue-router'

const saleRoutes: RouteRecordRaw = {
  path: '/sale',
  name: 'Sale',
  redirect: '/sale/order',
  meta: { title: '销售管理', icon: 'icon-send' },
  children: [
    {
      path: 'contract',
      name: 'SaleContract',
      component: () => import('@/views/sale/SalesContractList.vue'),
      meta: { title: '销售合同', permissions: ['sale:contract:view'] },
    },
    {
      path: 'order',
      name: 'SaleOrder',
      component: () => import('@/views/sale/OrderList.vue'),
      meta: { title: '销售订单', permissions: ['sale:order:view'] },
    },
    {
      path: 'delivery',
      name: 'SaleDelivery',
      component: () => import('@/views/sale/DeliveryList.vue'),
      meta: { title: '销货出库', permissions: ['sale:delivery:view'] },
    },
    {
      path: 'invoice',
      name: 'SaleInvoice',
      component: () => import('@/views/sale/InvoiceList.vue'),
      meta: { title: '销售发票', permissions: ['sale:invoice:view'] },
    },
    {
      path: 'collection',
      name: 'SaleCollection',
      component: () => import('@/views/sale/CollectionList.vue'),
      meta: { title: '收款结算', permissions: ['sale:collection:view'] },
    },
  ],
}

export default saleRoutes
